// extracted by mini-css-extract-plugin
export default {"tab-container":"ProgramsPage_tab-container__0bOzA","table-container":"ProgramsPage_table-container__Ze0sG","icon-container":"ProgramsPage_icon-container__hHeFn"};